import { useMemo, useState } from "react";
import { articles, categories } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";

const tabs = [{ key: "all", name: "全部栏目" }, ...categories.map((c) => ({ key: c.key, name: c.name }))];

export default function CategoriesSection() {
  const [active, setActive] = useState("all");

  const list = useMemo(() => {
    const source = active === "all" ? articles : articles.filter((a) => a.category === active);
    return source.slice(0, 6);
  }, [active]);

  const activeCategory = categories.find((c) => c.key === active);

  return (
    <section id="categories" className="scroll-mt-28 border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Columns"
          title="栏目精选"
          description="六大栏目持续更新，点击切换即可查看对应领域的编辑精选内容。"
        />

        <div className="mb-8 flex flex-wrap gap-2" role="tablist" aria-label="内容栏目">
          {tabs.map((tab) => {
            const isActive = active === tab.key;
            return (
              <button
                key={tab.key}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setActive(tab.key)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "border border-background-300 bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {tab.name}
              </button>
            );
          })}
        </div>

        {activeCategory && (
          <p className="mb-6 flex items-center gap-2 text-sm text-foreground-600">
            <i className={`${activeCategory.icon} text-primary-600`} aria-hidden="true"></i>
            {activeCategory.desc}
          </p>
        )}

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>

        {list.length === 0 && (
          <p className="rounded-lg border border-dashed border-background-300 py-12 text-center text-sm text-foreground-500">
            该栏目暂时还没有内容，我们正在整理中。
          </p>
        )}
      </div>
    </section>
  );
}